import { isArray } from "lodash";
import { useState, useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import { usePymbleApi } from "./usePymbleApi";

// const MY_ROOMLIST_END_POINT = `${api.myPymble}/room/`;
const MY_ROOMLIST_END_POINT = "/timetable/room/";

export type RoomDetail = {
  _id: string;
  RoomId: number;
  Capacity: number;
  name?: string;
  NameShort: string;
  NameLong: string;
  matches?: boolean;
};

export type BuildingDetail = {
  id?: number;
  name?: string;
  color?: string;
  Building?: string;
  BuildingShort?: string;
  BuildingId?: number;
  BuildingGeoLocation?: string;
  BuildingCapacity?: number;
  BuildingImageUrl?: string;
  children?: RoomDetail[];
  collapsed?: boolean;
  matches?: boolean;
};

/**
 * Hook for separate loading of a class list
 * for components
 */
export function useRoomList() {
  const [myRoomList, setMyRoomList] = useState<any>([]);
  const [myRoomListLoaded, setMyRoomListLoaded] = useState(false);

  const queryClient = useQueryClient();

  const { callApiS2: callApi, isAuthenticated } = usePymbleApi();

  // Load the contact list from api
  let queryKey = ["my-room-list"];

  const { isLoading, isError, data, error } = useQuery({
    queryKey,
    queryFn: () => callApi("GET", MY_ROOMLIST_END_POINT),
    enabled: isAuthenticated,
  });

  // When the data is loaded, set the state
  useEffect(() => {
    if (data && data.length) {
      let list = preProcessRoomList(data);

      // Sort by name
      list = sortRoomList(list);

      if (list) {
        setMyRoomList(list);
      }
      setMyRoomListLoaded(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data && !isLoading]);

  const refreshMyRoomList = async () => {
    queryClient.invalidateQueries({ queryKey });
  };

  // Only sort by start time at the moment
  const sortRoomList = (data: RoomDetail[]) => {
    return data.sort(function (a: RoomDetail, b: RoomDetail) {
      try {
        if (a && a?.NameShort && b && b?.NameShort) {
          var NameA = a?.NameShort;
          var NameB = b?.NameShort;
          if (NameA < NameB) {
            return -1;
          }
          if (NameA > NameB) {
            return 1;
          }
        }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (e) {
        /* squash */
      }
      // names must be equal or documents incorrect
      return 0;
    });
  };

  // Decorate as required
  const preProcessRoomList = (classdata: any) => {
    if (isArray(classdata)) {
      return classdata.map((c: any) => {
        c.NameShort = c?.Name?.Short || "";
        c.NameLong = c?.Name?.Long || "";
        return c;
      });
    } else {
      return [];
    }
  };

  return {
    isError,
    error,
    myRoomList,
    refreshMyRoomList,
    myRoomListLoaded,
  };
}
